import { useQuery } from "@tanstack/react-query";
import drEasyApi from "../Api/Customapi";
import { useParams } from "react-router-dom";

const fetchUserData = async ({ queryKey }) => {
  const [_key, slug, token] = queryKey;

  if (!token) return;

  try {
    const { data } = await drEasyApi.get(`/api/${slug}/User/GetUserData`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return data;
  } catch (error) {
    if (error.response?.status === 404) {
      return null; // No user data found, don't retry forever
    }
    throw error; // other errors will be retried by React Query
  }
};

export const useGetUserData = () => {
  const { slug } = useParams();

  const token =
    localStorage.getItem(`userTkn-${slug}`) ||
    sessionStorage.getItem(`userTkn-${slug}`);

  return useQuery({
    queryKey: ["userData", slug, token],
    queryFn: fetchUserData,
    enabled: !!slug && !!token,
    retry: (failureCount, error) => {
      // Don't retry if not found
      if (error?.response?.status === 404) return false;
      return failureCount < 3;
    },
    staleTime: 5 * 60 * 1000, // optional: cache for 5 minutes
  });
};
